// Initializes a lightweight Swiper instance on every product-card image
// gallery (.product-item__swiper), so shoppers can flick through a
// product's photos without opening the product page.
//
// Runs on initial load AND watches the page for new cards being added
// later (infinite scroll, quick view, search results, "you may also
// like" carousels, the Fahhar Look tag page, etc.) via MutationObserver,
// so it never needs to be wired into any specific section's own JS.
(function () {
  function initCard(el) {
    if (el.dataset.swiperReady) return;
    el.dataset.swiperReady = 'true';

    if (!window.flu || !window.flu.chunks || !window.flu.chunks.swiper) return;

    import(window.flu.chunks.swiper).then(function (mod) {
      var Swiper = mod.Swiper;
      var Pagination = mod.Pagination;

      new Swiper(el, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: el.querySelector('.product-item__swiper-pagination'),
          clickable: true
        }
      });
    });
  }

  function scan(root) {
    var scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product-item__swiper').forEach(initCard);
  }

  function start() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('.product-item__swiper')) {
            initCard(node);
          }

          if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();